import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import {hasServerErrorCode, ServerErrorResponse} from './server-error-code';

export interface StandardVersionSnapshot {
  id?: string;
  version?: number | null;
}

export const STANDARD_VERSION_HEADER = 'X-Standard-Version';
export const STANDARD_EXPECTED_VERSION_HEADER = 'expectedVersion';
export const STANDARD_VERSION_CONFLICT = 'STANDARD_VERSION_CONFLICT';
const HTTP_CONFLICT = 409;
const EMPTY_HEADER = '';
const MIN_VERSION = 0;

export function standardVersionHeaders(snapshot: StandardVersionSnapshot, headers = new HttpHeaders()): HttpHeaders {
  return snapshot && snapshot.version != null
    ? headers.set(STANDARD_EXPECTED_VERSION_HEADER, String(snapshot.version)) : headers;
}

export function standardVersionBody<T>(snapshot: StandardVersionSnapshot, body: T): T & { expectedVersion?: number } {
  return snapshot && snapshot.version != null
    ? Object.assign({}, body, { expectedVersion: snapshot.version }) : body;
}

export function trackStandardVersion<T>(snapshot: StandardVersionSnapshot,
                                      request: Observable<HttpResponse<T>>): Observable<HttpResponse<T>> {
  const capturedVersion = snapshot && snapshot.version;
  return request.do(response => {
    const saved = savedStandardVersion(response);
    if (snapshot && snapshot.version === capturedVersion && saved != null) {
      snapshot.version = saved;
    }
  });
}

export function savedStandardVersion<T>(response: HttpResponse<T>): number {
  const header = response.headers && response.headers.get(STANDARD_VERSION_HEADER);
  const body = response.body as StandardVersionSnapshot;
  if (header != null && header.trim() !== EMPTY_HEADER) {
    const version = Number(header);
    return Number.isSafeInteger(version) && version >= MIN_VERSION ? version : null;
  }
  return body && body.version != null ? body.version : null;
}

export function isStandardVersionConflict(error: ServerErrorResponse): boolean {
  return !!error && error.status === HTTP_CONFLICT && hasServerErrorCode(error, STANDARD_VERSION_CONFLICT);
}

export function standardResponseWithVersion<T extends StandardVersionSnapshot>(response: HttpResponse<T>): HttpResponse<T> {
  const version = savedStandardVersion(response);
  return response.body && version != null
    ? response.clone({ body: Object.assign({}, response.body, { version }) }) : response;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/standard-version.ts